const com = {
  BLOCKED: {
    message: 'Action not allowed. Your company only has access to read information',
    field: 'status',
    code: 'COM_1'
  },
  IMAGE_INVALID_FORMAT: {
    message: 'File not supported, only PNG and JPG files are accepted',
    field: 'image',
    code: 'COM_2'
  },
  IMAGE_TO_SMALL: {
    message: 'The image is too small, it has to be at least 48px height',
    field: 'image',
    code: 'COM_3'
  },
  IMAGE_EXCEEDED_SIZE: {
    message: 'The image exceeded the size limit',
    field: 'image',
    code: 'COM_4'
  }
};

module.exports = com;
